module.exports = "<app-slider></app-slider>\n<app-home-section></app-home-section>\n<!-- <app-top-banner></app-top-banner>\n<app-home-member></app-home-member>\n<app-newsletter></app-newsletter>\n<app-instagram></app-instagram> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 1085
// module chunks = 0